// Неотрицательное число, разделитель — точка или запятая, максимум 2 знака после разделителя
export const taxAmountFormat = (value: string | number): boolean => {
  if (value === null || value === undefined || String(value).trim() === '') return true;
  return /^\d+([.,]\d{1,2})?$/.test(String(value).trim());
};

// Приводит запятую к точке и возвращает число (0 для пустого/невалидного значения)
export const normalizeTaxAmount = (value: string | number): number => Number(String(value).trim().replace(',', '.')) || 0;

// Ставка НДС: целое число 0–100 (пустое значение допустимо — ставка не обязательна)
export const taxRateFormat = (value: string | number): boolean => {
  if (value === null || value === undefined || String(value).trim() === '') return true;
  if (!/^\d+$/.test(String(value).trim())) return false;
  const rate = Number(String(value).trim());
  return rate >= 0 && rate <= 100;
};

// Итого НДС по ставке: round(totalWithoutTax × ставка / 100, 2)
export const calcTaxAmountByRate = (totalWithoutTax: number, rate: number): number => Math.round(totalWithoutTax * rate) / 100;

// Неблокирующее предупреждение: |сумма − расчётная по ставке| / расчётная > 1%
// При нулевой/отсутствующей расчётной сумме предупреждение не показываем (деление на 0).
export const isTaxAmountDeviating = (amount: number, expected: number, thresholdPercent = 1): boolean => {
  if (!expected) return false;
  return (Math.abs(amount - expected) / expected) * 100 > thresholdPercent;
};
